window.appLoader = {
  loadedScripts: [],
  applicationLoaded: false,
  assetLoadTimeout: 30000,
  offerXHR: null,
  jsLoadTimeouts: {},
  loadAllAssets: function () {
    // Get options
    var offerIdentifier = window.location.pathname.split('/')[3];
    var params = window.location.search;
    params = params.slice(1, params.length);
    params += `&session_identifier=${window.session_identifier}`;
    params += `&show_fastpass_survey=${window.show_fastpass_survey}`;
    var date = new Date();
    var jsonOfferUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      '/router/offers/' +
      offerIdentifier +
      '/get_options.json?' +
      'tz=' +
      date.getTimezoneOffset() +
      '&time=' +
      date.getTime() +
      '&' +
      params;

    this.loadAjaxResource(
      jsonOfferUrl,
      function (data) {
        this.options = data;
        appLoader.checkCompletion();
      },
      appLoader.handleLoadingError
    );

    // Translations
    this.loadAjaxResource(
      '/router/assets/i18n.json?locale=' + window.I18n.locale,
      function (data) {
        window.I18n.translations = data;

        appLoader.checkCompletion();
      },
      appLoader.handleLoadingError,
      true
    );

    // Constants
    this.loadAjaxResource(
      '/router/assets/constants.json',
      function (data) {
        window.ActiveEnum = data.active_enum;
        window.Constants = data.constants;
        window.supported_country_abbrs = data.supported_country_abbrs;

        appLoader.checkCompletion();
      },
      appLoader.handleLoadingError,
      true
    );
  },
  checkCompletion: function () {
    /*
      This logic controls the 4 ring loading indicator. Each ring lights up when a necessary asset is fully loaded.
      When all 4 are available, the application is loaded.
      This allows a user stuck on the loading screen to send us a screenshot to debug loading issues.
    */
    var loadCount = 0;
    var indicators = document.getElementById('loading-animation');
    /* application.js - loaded via script tag */
    if (typeof ReactDOM !== 'undefined') {
      loadCount++;
      indicators.getElementsByClassName('app')[0].className =
        'indicator active app';
    }
    /* localization assets for the current country */
    if (
      typeof window.I18n === 'object' &&
      typeof window.I18n.translations === 'object' &&
      typeof window.I18n === 'object'
    ) {
      loadCount++;
      indicators.getElementsByClassName('i18n')[0].className =
        'indicator active i18n';
    }
    /* constants */
    if (typeof window.Constants === 'object') {
      loadCount++;
      indicators.getElementsByClassName('constants')[0].className =
        'indicator active constants';
    }
    /*
      get_options ajax call.
      This is typically the longest download due to server-side processing.
      After initial load, it is nearly guaranteed to be the longest, since the other 3 assets will be cached by the browser.
     */
    if (window.options) {
      loadCount++;
      indicators.getElementsByClassName('options')[0].className =
        'indicator active options';
    }
    if (loadCount === 4) {
      appLoader.loadApplication();
    }
  },
  handleLoadingError: function (e) {
    document.getElementById('loading-animation').className = 'hidden';
    document.getElementById('reload-button').className = '';
    if (e) {
      console.log(e);
      Sentry.captureException(e);
    }
  },
  customError: function (message) {
    document.getElementById('loading-animation').style.display = 'none';
    document.querySelector('#loading-screen > img').style.display = 'none';
    document.getElementById('loading-error-message').innerHTML = message;
    document.getElementById('reload-button').className = 'hidden';
  },
  reloadAssets: function () {
    window.location.reload();
  },
  loadApplication: function () {
    if (!appLoader.applicationLoaded) {
      appLoader.applicationLoaded = true;
      document
        .getElementById('router-app')
        .appendChild(document.createElement('div'))
        .setAttribute('id', 'router-react');
      ReactDOM.render(
        React.createElement(RouterLoader, { options: window.options }, null),
        document.getElementById('router-react')
      );
    }
  },
  hideLoader: function () {
    document.getElementById('loading-screen').className = 'loaded';
    if (typeof newrelic !== 'undefined') {
      try {
        newrelic.finished();
      } catch (e) {
        //
      }
    }
  },
  loadJS: function (src, callback, errorCallback) {
    var script = document.createElement('script');
    appLoader.loadedScripts.push(script);
    script.setAttribute('src', src);
    var that = this;
    if (callback) {
      script.onreadystatechange = script.onload = function () {
        clearTimeout(that.jsLoadTimeouts[src]);
        callback();
      };
    }
    document.getElementsByTagName('head')[0].appendChild(script);

    if (typeof errorCallback === 'function') {
      this.jsLoadTimeouts[src] = setTimeout(function () {
        errorCallback();
      }, this.assetLoadTimeout);
    }
  },
  loadAjaxResource: function (src, callback, errorCallback, cacheable) {
    if (cacheable && this.hasLocalStorage()) {
      var jsonString = localStorage.getItem(src);
      try {
        var json = JSON.parse(jsonString);
        if (
          json !== null &&
          json.release_timestamp == window.release_timestamp
        ) {
          callback(json);
          return;
        }
      } catch (e) {
        // Allow request to continue
      }
    }

    this.offerXHR = new XMLHttpRequest();
    this.offerXHR.timeout = this.assetLoadTimeout;
    this.offerXHR.onreadystatechange = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          try {
            var data = JSON.parse(this.responseText);

            if (cacheable && appLoader.hasLocalStorage()) {
              try {
                localStorage.setItem(src, JSON.stringify(data));
              } catch (e) {
                // Do nothing. Protect against localstorage size limit - QuotaExceededError
              }
            }
            callback(data);
          } catch (e) {
            e.message = 'loadAjaxResource JSON parse error';
            e.responseText = this.responseText;
            appLoader.handleLoadingError(e);
          }
        } else {
          appLoader.handleLoadingError();
        }
      }
    };

    this.offerXHR.ontimeout = function () {
      if (!window.options) {
        appLoader.handleLoadingError();
      }
    };

    var timestamped_src = src;
    if (cacheable) {
      timestamped_src =
        src +
        (src.indexOf('?') === -1 ? '?' : '&') +
        'time=' +
        window.release_timestamp;
    }
    this.offerXHR.open('GET', timestamped_src, true);
    this.offerXHR.send();
  },

  hasLocalStorage: function () {
    try {
      if (typeof window.localStorage !== 'object') {
        return false;
      }
    } catch (e) {
      return false;
    }

    try {
      return !!window.localStorage;
    } catch (e) {
      return !0;
    }
  },
};

if (window.error_message === '') {
  window.appLoader.loadAllAssets();
} else {
  window.appLoader.customError(window.error_message);
}
